// extracted by mini-css-extract-plugin
export default {"BoA-individual-pages":"Writing_BoA-individual-pages__pp20j","fade":"Writing_fade__7xQCc"};